export const isDefined = <T>(thing: T | undefined): thing is T => typeof thing !== 'undefined';
